import { Box, LinearProgress } from "@mui/material";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { StoreInterfaces } from "../../types/store/StoreInterfaces";
import Header from "../Navigation/Header";
import SideMenu from "../Navigation/SideMenu/SideMenu";
import Overlay from "../Overlay/Overlay";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const isLoading = useSelector((state: StoreInterfaces) => state.ui.loading);

  return (
    <Box sx={{ display: "flex" }}>
      <Overlay show={isLoading} />
      <SideMenu />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        {isLoading && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              zIndex: (t) => t.zIndex.drawer + 2,
            }}
          >
            <LinearProgress />
          </Box>
        )}

        <Box
          sx={{
            width: { xs: "95%", sm: "95%", md: "98%", lg: "90%", xl: "80%" },
            mx: "auto",
          }}
        >
          <Header />
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            py: 3,
            width: { xs: "95%", sm: "95%", md: "98%", lg: "90%", xl: "80%" },
            mx: "auto",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
